import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConsolidatedInvoice } from 'src/app/models/consolidated_invoice.model';
import { Invoice } from 'src/app/models/invoice.model';
import { InvoiceService } from 'src/app/services/invoice_service.service';
import { InvoiceDialogComponent } from './invoice-dialog/invoice-dialog.component';
import { UpdateInvoiceDialogComponent } from './update-invoice-dialog/update-invoice-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIcon } from '@angular/material/icon';
import { KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-provider-billing',
    templateUrl: './provider-billing.component.html',
    styleUrls: ['./provider-billing.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatSelect, MatOption, MatLabel, MatInput, MatButton, MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, KeyValuePipe]
})
export class ProviderBillingComponent implements OnInit {
    loadingInvoices: boolean = false;
    generatingInvoices: boolean = false;
    currentMonth: number = new Date().getMonth();
    currentYear: number = new Date().getFullYear();
    selectedInvoices: any[] = [];
    consolidatedInvoices: ConsolidatedInvoice[] = [];
    columnsToDisplay: string[] = [
        'Name',
        'Business Name',
        'Email Address',
        'Phone Number',
        'Total Bill',
        'Amount Paid',
        'Amount Still Owed',
        'View Invoices',
    ];
    dataSource = new MatTableDataSource(this.consolidatedInvoices);
    filterForm = new UntypedFormGroup({
        year: new UntypedFormControl(new Date().getFullYear()),
        month: new UntypedFormControl(new Date().getMonth() + 1),
    });
    months = new Map([
        [1, 'January'],
        [2, 'February'],
        [3, 'March'],
        [4, 'April'],
        [5, 'May'],
        [6, 'June'],
        [7, 'July'],
        [8, 'August'],
        [9, 'September'],
        [10, 'October'],
        [11, 'November'],
        [12, 'December'],
    ]);

    constructor(private invoiceService: InvoiceService, public dialog: MatDialog) { }

    ngOnInit() {
        this.getInvoices();
    }

    getInvoices(year?: number, month?: number): void {
        this.loadingInvoices = true;
        let queryParameters = new Map();

        if (!year && !month) {
            queryParameters.set('year', this.filterForm.controls.year.value);
            queryParameters.set('month', this.filterForm.controls.month.value);
            this.currentYear = this.filterForm.controls.year.value;
            this.currentMonth = this.filterForm.controls.month.value;
        } else {
            queryParameters.set('year', year);
            queryParameters.set('month', month);
            this.currentYear = this.filterForm.controls.year.value;
            this.currentMonth = this.filterForm.controls.month.value;
        }

        this.invoiceService.getAll([], queryParameters).subscribe(
            (response) => {
                this.consolidateInvoices(response);
                this.selectedInvoices = response;
                this.loadingInvoices = false;
            },
            () => (this.loadingInvoices = false)
        );
    }
    consolidateInvoices(response: any[]): void {
        this.consolidatedInvoices = [];
        response.forEach((invoice) => {
            let indexOfConsolidatedInvoice =
                this.consolidatedInvoices.findIndex(
                    (consolidatedInvoice) =>
                        consolidatedInvoice.serviceProviderId ==
                        invoice.serviceProviderId
                );

            if (indexOfConsolidatedInvoice >= 0) {
                this.consolidatedInvoices[indexOfConsolidatedInvoice].invoices.push(invoice);
                this.consolidatedInvoices[indexOfConsolidatedInvoice].totalOwedForMonth = this.consolidatedInvoices[indexOfConsolidatedInvoice].totalOwedForMonth + invoice.billableAmount;
                if (invoice.paid) {
                    this.consolidatedInvoices[indexOfConsolidatedInvoice].amountPaid = this.consolidatedInvoices[indexOfConsolidatedInvoice].amountPaid + invoice.billableAmount;
                }
            } else {
                let newConsolidatedInvoice = this.consolidatedInvoiceMapper(invoice);
                this.consolidatedInvoices.push(newConsolidatedInvoice);
            }

        });
        this.consolidatedInvoices.forEach(consolidatedInvoice => {
            consolidatedInvoice.amountOwed = (consolidatedInvoice.totalOwedForMonth - consolidatedInvoice.amountPaid).toFixed(2).toString();
        });
        this.dataSource.data = this.consolidatedInvoices;
    }

    openDetailsDialog(invoices: any[]): void {

        let dialogRef = this.dialog.open(InvoiceDialogComponent, {
            width: '75%',
            data: invoices,
        });
        dialogRef.afterClosed().subscribe(() => {
            this.getInvoices(this.currentYear, this.currentMonth);
        })
    }

    openUpdateInvoiceDialog(): void {
        let dialogRef = this.dialog.open(UpdateInvoiceDialogComponent, {
            width: '700px',
        });
        dialogRef.afterClosed().subscribe(() => {
            this.getInvoices(this.currentYear, this.currentMonth);
        })
    }


    getNewInvoices(): void {
        this.getInvoices(this.filterForm.value.year, this.filterForm.value.month);

    }

    
    consolidatedInvoiceMapper(invoice: Invoice): ConsolidatedInvoice {
        let newConsolidatedInvoice: ConsolidatedInvoice = new ConsolidatedInvoice();
        newConsolidatedInvoice.id = invoice.invoiceId;
        newConsolidatedInvoice.emailAddress = invoice.serviceProvider.emailAddress;
        newConsolidatedInvoice.city = invoice.serviceProvider.city;
        newConsolidatedInvoice.zipCode = invoice.serviceProvider.zipCode.toString();
        newConsolidatedInvoice.address = invoice.serviceProvider.address;
        newConsolidatedInvoice.businessName = invoice.serviceProvider.businessName;
        newConsolidatedInvoice.name = invoice.serviceProvider.name;
        newConsolidatedInvoice.monthBilled = invoice.month;
        newConsolidatedInvoice.yearBilled = invoice.year;
        newConsolidatedInvoice.primaryPhoneNumber = invoice.serviceProvider.primaryPhoneNumber;
        newConsolidatedInvoice.serviceProviderId = invoice.serviceProviderId;
        newConsolidatedInvoice.totalOwedForMonth = invoice.billableAmount;
        newConsolidatedInvoice.state = invoice.serviceProvider.state;
        newConsolidatedInvoice.invoices = [];
        newConsolidatedInvoice.invoices.push(invoice);
        
        if (invoice.paid) {
            newConsolidatedInvoice.amountPaid = invoice.billableAmount;
        }

        return newConsolidatedInvoice;
    }


    keyPressNumbers(event: any) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }
}
